import { alpha, createTheme } from "@mui/material";

const defaultTheme = createTheme({
  direction: "rtl",
  typography: {
    fontFamily: "IRANSans",
  },
  components: {
    MuiAvatar: {
      defaultProps: {
        variant: "rounded",
      },
    },
    MuiTypography: {
      styleOverrides: {
        root: {
          // color: "text.primary",
        },
      },
    },
    MuiFormControl: {
      styleOverrides: {
        root: {
          ".MuiFormLabel-root": {
            color: "#00000099",

            "&.Mui-error": {
              color: "#d32f2f !important",
            },
          },
          ".MuiFormHelperText-root": {
            // color: "#9ea1a4",
            fontSize: 11,
          },
          ".MuiInputBase-input": {
            paddingInline: "10px",
          },
          ".MuiInputBase-root": {
            borderRadius: "8px",
            padding: 0,
            overflow: "hidden",

            "&.Mui-disabled": {
              cursor: "no-drop !important",
            },

            "&.MuiOutlinedInput-root": {
              "& fieldset": {
                border: "2px solid #e7ecf4",
              },
              "&:hover": {
                "& fieldset": {
                  border: "2px solid #321f58",
                },
              },
              "&.Mui-error": {
                "& fieldset": {
                  border: "2px solid #d32f2f !important",
                },

                ".MuiInputAdornment-root": {
                  borderColor: "#d32f2f",
                  color: "#d32f2f !important",
                },
              },
            },
            ".MuiInputAdornment-root": {
              paddingRight: "26px",
              paddingLeft: "14px",
              color: "#495057",
              border: "none",
              height: "60px",
              width: "32px",
            },
            ".MuiInputAdornment-positionStart": {
              borderRight: "2px solid #e7ecf4",
            },
            ".MuiInputAdornment-positionEnd": {
              borderLeft: "2px solid #e7ecf4",
            },
            "&.MuiInputBase-multiline": {
              ".MuiInputBase-inputMultiline": {
                padding: 16,
              },
            },
          },
          "& .MuiInput-underline-none:before": {
            borderBottom: "none",
          },
          "& .MuiInput-underline-none:after": {
            borderBottom: "none",
          },
        },
      },
    },
    MuiCard: {
      defaultProps: {
        variant: "outlined",
      },
      styleOverrides: {
        root: {
          borderRadius: 8,
        },
      },
    },
    MuiCardHeader: {
      styleOverrides: {
        subheader: {
          color: "text.primary",
        },
        avatar: {
          marginLeft: "16px",
          marginRight: 0,
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: 8,
        },
      },
    },
    MuiListItemButton: {
      styleOverrides: {
        root: {
          "&.active": {
            "&:hover": {
              backgroundColor: "#5349bf",
              ".MuiTouchRipple-child ": {
                backgroundColor: "#5349bf",
              },
            },
          },

          "&:hover": {
            ".MuiTouchRipple-child ": {
              backgroundColor: "#5349bf",
            },
          },
        },
      },
    },
    MuiListItemIcon: {
      styleOverrides: {
        root: {
          minWidth: "0 !important",
        },
      },
    },
    MuiListSubheader: {
      styleOverrides: {
        root: {
          "&.MuiAutocomplete-groupLabel": {
            color: "#39245d",
            fontWeight: 600,
            fontSize: 16,
          },
        },
      },
    },
    MuiSkeleton: {
      styleOverrides: {
        root: {
          borderRadius: "8px",
          width: "100%",
        },
      },
    },
    MuiTabs: {
      styleOverrides: {
        root: {
          ".MuiTab-root": {
            color: "#575757",

            "&.Mui-selected": {
              color: "#39245d",
            },
          },
        },
      },
    },
    MuiSelect: {
      styleOverrides: {
        icon: ({ theme }: any) => ({
          color: theme.palette.text.primary,
        }),
      },
    },
    MuiCheckbox: {
      styleOverrides: {
        root: {
          color: "#d1d4d9",
          "&.MuiCheckbox-indeterminate .MuiSvgIcon-root": {
            color: "#39245d",
          },
        },
      },
    },
    MuiRadio: {
      styleOverrides: {
        root: {
          color: "#d1d4d9",
        },
      },
    },
    MuiTableCell: {
      styleOverrides: {
        root: {
          margin: "12px",
          padding: "12px !important",
        },
      },
    },
    MuiSvgIcon: {
      styleOverrides: {
        root: { color: "text.primary" },
      },
    },
  },
});

export const lightTheme = createTheme(defaultTheme, {
  components: {
    MuiCssBaseline: {
      styleOverrides: {
        body: {
          input: {
            "&:-webkit-autofill": {
              WebkitBoxShadow: `0 0 0 100px #fff  inset !important`,
              WebkitTextFillColor: `#444 !important`,
              borderRadius: "0 !important",
            },
          },
        },
      },
    },
  },
  palette: {
    // primary: PaletteColor;
    // secondary: PaletteColor;
    // error: PaletteColor;
    // warning: PaletteColor;
    // info: PaletteColor;
    // success: PaletteColor;

    mode: "light",
    primary: {
      main: "#39245d",
      dark: "#39245d",
      light: "#39245d",
    },
    secondary: {
      main: "#ffffff08",
    },
    background: {
      default: "#f7f7f7",
      paper: "#fff",
      light: "#e2e8f0",
      extraLight: "#edeef0",
      tab: "#f6f2fd",
      chat: {
        primary: "#ece4ff",
        secondary: "#ebebeb",
        button: "#444",
      },
    },
    text: {
      primary: "#444",
      secondary: "#fff",
      light: "#9ea1a4",
    },
    notification: {
      primary: "#444",
      secondary: "#9ea1a4",
    },
    success: {
      primary: "#169f27",
      secondary: "#ea580b",
    },
    error: {
      primary: "#d32f2f",
      secondary: "#f92929",
      background: "rgba(255, 113, 91, 0.25)",
    },
    border: {
      light: "#e6e6e6",
      main: "#e7ecf4",
      error: "#FF715B",
    },
    chip: {
      primary: "#A78BE6",
      primarySecond: "rgba(59, 93, 231, .18)",
      warning: "#EEB902",
      warningSecond: "rgba(238, 185, 2, .18)",
      success: "#45CB85",
      successSecond: "rgba(69, 203, 133, .18)",
      danger: "#FF715B",
      dangerSecond: "rgba(255, 113, 91, .18)",
    },
    gradientButton: {
      base: "linear-gradient(216deg, rgb(98 77 144) 0%, rgb(61 42 103) 100%)",
      selected:
        "linear-gradient(216deg, rgb(98 9 180) 0%, rgb(61 42 103) 100%)",
      hover: "linear-gradient(216deg, rgb(98 77 144) 0%, rgb(61 42 103) 100%)",
    },
  },
});

export const darkPalette = createTheme(defaultTheme, {
  components: {
    MuiCssBaseline: {
      styleOverrides: {
        body: {
          input: {
            "&:-webkit-autofill": {
              WebkitBoxShadow: `0 0 0 100px #131a26  inset !important`,
              WebkitTextFillColor: `#a3a3a3 !important`,
              borderRadius: "0 !important",
            },
          },
        },
      },
    },
  },
  palette: {
    mode: "dark",
    primary: {
      main: "#39245d",
      dark: "#5349bf",
      light: "#6c60c9",
    },
    secondary: {
      main: "#ffffff08",
    },
    background: {
      default: "#131a26",
      paper: "#212937",
      chat: {
        primary: "#24375e",
        secondary: "#344c7d",
        button: "#e6e6e6",
      },
    },
    text: {
      primary: "#a3a3a3",
      secondary: "#fff",
      light: "#ece4ff",
    },
    notification: {
      primary: "#fff",
      secondary: "#a3a3a3",
    },
    success: {
      primary: "#169f27",
      secondary: "#ea580b",
    },
    error: {
      primary: "#d32f2f",
      secondary: "#f92929",
      background: "rgba(255, 113, 91, 0.25)",
    },
    border: {
      light: "#e6e6e6",
      main: "#a3a3a3",
      error: "#FF715B",
    },
    chip: {
      primary: "#A78BE6",
      primarySecond: "rgba(59, 93, 231, .18)",
      warning: "#EEB902",
      warningSecond: "rgba(238, 185, 2, .18)",
      success: "#45CB85",
      successSecond: "rgba(69, 203, 133, .18)",
      danger: "#FF715B",
      dangerSecond: "rgba(255, 113, 91, .18)",
    },
  },
});

export const darkTheme = createTheme(darkPalette, {
  components: {
    MuiCssBaseline: {
      styleOverrides: `
        input:-webkit-autofill,
        input:-webkit-autofill:hover,
        input:-webkit-autofill:focus,
        input:-webkit-autofill:active {
          -webkit-box-shadow: 0 0 0 30px ${darkPalette.palette.background.paper} inset !important;
          -webkit-text-fill-color: ${darkPalette.palette.text.primary} !important; /* Ensures text color is inherited */
          border-radius: 0 !important; /* Ensure no border-radius is applied */
          padding-left: 8px;
          }
      `,
    },
    MuiFormControl: {
      styleOverrides: {
        root: {
          "&.MuiFormControl-root": {
            ".MuiFormLabel-root": {
              color: darkPalette.palette.text.primary,
              // fontFamily: "IRANSans !important",
            },
            ".MuiInputBase-root": {
              color: darkPalette.palette.text.primary,

              "&.Mui-disabled": {
                ".MuiInputBase-input": {
                  color: `${alpha(
                    darkPalette.palette.text.primary,
                    0.5
                  )} !important`,
                  textFillColor: "inherit !important",
                },
              },

              "&.MuiInput-root": {
                input: {
                  "&:-webkit-autofill": {
                    WebkitBoxShadow: `0 0 0 100px ${darkPalette.palette.background.paper} inset !important`,
                    WebkitTextFillColor: `${darkPalette.palette.text.primary} !important`,
                    borderRadius: 0,
                  },
                },
                "& fieldset": {
                  border: `2px solid ${darkPalette.palette.text.primary}`,
                },
                "&:hover": {
                  "& fieldset": {
                    // border: `2px solid ${darkPalette.palette.text.primary}`,
                  },
                },
              },
              ".MuiInputAdornment-root": {
                color: darkPalette.palette.text.primary,
                borderColor: `${darkPalette.palette.text.primary}`,
              },
            },
          },
          ".MuiInputBase-root": {
            borderRadius: "8px",
            padding: 0,

            "&.Mui-disabled": {
              cursor: "no-drop !important",
            },

            "&.MuiOutlinedInput-root": {
              "& fieldset": {
                border: "2px solid #a3a3a3",
              },
              "&:hover": {
                "& fieldset": {
                  border: "2px solid #fff",
                },
              },
              "&.Mui-error": {
                "& fieldset": {
                  border: "2px solid #d32f2f !important",
                },

                ".MuiInputAdornment-root": {
                  borderColor: "#d32f2f",
                  color: "#d32f2f !important",
                },
              },
            },
            ".MuiInputAdornment-root": {
              paddingRight: "28px",
              paddingLeft: "14px",
              color: "#495057",
              border: "none",
              height: "60px",
              width: "32px",
            },
            ".MuiInputAdornment-positionStart": {
              borderRight: "2px solid #e7ecf4",
            },
            ".MuiInputAdornment-positionEnd": {
              borderLeft: "2px solid #e7ecf4",
            },
            "&.MuiInputBase-multiline": {
              ".MuiInputBase-inputMultiline": {
                padding: 16,
              },
            },
          },
        },
      },
    },

    MuiLoadingButton: {
      styleOverrides: {
        root: {
          "&.Mui-disabled": {
            color: alpha(darkPalette.palette.text.primary, 0.5),
          },
        },
      },
    },
    MuiTabs: {
      styleOverrides: {
        root: {
          ".MuiTab-root": {
            "&.Mui-selected": {
              color: darkPalette.palette.text.primary,
            },
          },
          ".MuiTabs-indicator": {
            background: darkPalette.palette.background.default,
          },
        },
      },
    },

    // MuiCard: {
    //   styleOverrides: {
    //     root: {
    //       background: darkPalette.palette.secondary.main
    //     }
    //   }
    // },

    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: 8,
          background: darkPalette.palette.primary.main,
          color: darkPalette.palette.text.secondary,
          "&:hover": {
            background: darkPalette.palette.primary.main,
          },
        },
      },
    },

    MuiSvgIcon: {
      styleOverrides: {
        root: { color: darkPalette.palette.text.primary },
      },
    },
  },
});
